import {Injectable} from '@angular/core';

import {Observable} from 'rxjs/Observable';
import {ConfigService} from '../../../../core/services/config.service';
import {RequestService} from '../../../../core/services/request.service';

import {AccountDetails} from './details/account-details.model';

@Injectable()
export class AccountService {
    constructor(private configService: ConfigService, private requestService: RequestService) {
    }

    updateSmtpDetails(accountId: string, details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.editSmtp.api +
            '/' +
            accountId;
        return this.requestService.post(url, details);
    }

    delete(details: any): Observable<AccountDetails> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.delete.api;
        return this.requestService.post(url, details);
    }

    add(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.add.api;
        return this.requestService.post(url, details);
    }

    editMain(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.adminEdit.api;
        return this.requestService.post(url, details);
    }

    editSegments(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.editSegments.api;
        return this.requestService.post(url, details);
    }

    editAddresses(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.editAddresses.api;
        return this.requestService.post(url, details);
    }

    editSmtp(details: any, id: string) {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.editSmtp.api +
            '/' +
            id;
        return this.requestService.post(url, details);
    }

    invite(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.invite.api;
        return this.requestService.post(url, details);
    }

    saveAddress(details: object): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.communication.add.api;
        return this.requestService.post(url, details);
    }

    getAccountDetails(id: string): Observable<AccountDetails> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.details.api +
            '/' +
            id;
        return this.requestService.get(url);
    }

    getCurrencyDto() {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.dictionary.currency.api;
        return this.requestService.get(url, {verbose: true});
    }

    getCurrencyDict() {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.dictionary.currency.api;
        return this.requestService.get(url);
    }

    getConsolidationOrdersFrequencyList() {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.dictionary.consolidationOrdersFrequency.api;
        return this.requestService.get(url);
    }

    getDetailsMainFields(showAllowPayTM: boolean = false) {
        let fields = [
            {
                key: (data: any) => {
                    if (data['domains'] && data['domains'][0]) {
                        return [data['domains'][0].name];
                    } else {
                        return null;
                    }
                },
                label: 'Domains',
                type: 'list'
            }, {
                key: 'accountId',
                label: 'Account ID',
                type: 'text'
            }, {
                key: 'name',
                label: 'Name',
                type: 'text'
            }, {
                key: 'email',
                label: 'E-mail',
                type: 'text'
            }, {
                key: 'additionalName',
                label: 'Additional Name',
                type: 'text'
            }, {
                key: 'language.configValue',
                label: 'Language',
                type: 'text'
            },
            // {
            //     key: 'currency.configValue',
            //     label: 'Currency',
            //     type: 'text'
            // },
            {
                key: 'classificationLevel.configValue',
                label: 'Classification Level',
                type: 'text'
            }, {
                key: 'watermark',
                label: 'Print Name',
                type: 'text'
            }, {
                key: 'certificateIncorporationURL',
                label: 'Certificate Incorporation',
                type: 'link',
                config: {
                    placeholder: 'View'
                }
            }, {
                key: _ => {
                    return this.configService.getSphinxUrlUnsecured(
                        'agora',
                        _.signedDocumentBucket,
                        _.signedDocumentKey
                    );
                },
                label: 'Acknowledged Terms & Conditions',
                type: 'link',
                config: {
                    placeholder: 'View'
                }
            },
            {
                key: 'procureFromContractedSuppliers',
                label: 'Procure from My Contracted Suppliers only',
                type: 'boolean'
            }
        ];
        // deprecate
        // if (showAllowPayTM) {
        //     fields.push({
        //         key: 'allowPayTM',
        //         label: 'Allow PayTM',
        //         type: 'boolean'
        //     });
        // }

        return fields;
    }


    getDetailsSegmentsFields() {
        let fields = [
            {
                key: 'accountSellerSegments',
                label: 'Seller Managed Segments',
                getter: item => {
                    return item.configValue;
                },
                type: 'list'
            },
            {
                key: 'accountAccreditations',
                label: 'Account Accreditations',
                getter: item => {
                    return item.configValue;
                },
                type: 'list'
            },
            {
                key: 'accountSegments',
                label: 'Account Segments',
                getter: item => {
                    return item.configValue;
                },
                type: 'list'
            },
            {
                key: 'accountComputedSegments',
                label: 'Account Computed Segments',
                getter: item => {
                    return item.configValue;
                },
                type: 'list'
            },
            {
                key: 'organizationType.configValue',
                label: 'Organization Type',
                type: 'text'
            }
        ];
        return fields;
    }

    getDetailsAddressesFields(domain: string) {
        let fields = [
            {
                key: 'shipToAddresses',
                label: 'Shipping Addresses',
                getter: item => {
                    return this.getFormattedAddress(item);
                },
                type: 'list'
            },
            {
                key: 'billToAddresses',
                label: 'Billing Addresses',
                getter: item => {
                    return this.getFormattedAddress(item);
                },
                type: 'list'
            },
            {
                key: item => {
                    return item.mainAddress ? this.getFormattedAddress(item.mainAddress) : '';
                },
                label: 'Primary Address',
                type: 'text'
            },
            {
                key: item => {
                    return item.defaultShipToAddress
                        ? this.getFormattedAddress(item.defaultShipToAddress)
                        : '';
                },
                label: 'Default Shiping Address',
                type: 'text'
            },
            {
                key: item => {
                    return item.defaultBillToAddress
                        ? this.getFormattedAddress(item.defaultBillToAddress)
                        : '';
                },
                label: 'Default Billing Address',
                type: 'text'
            }
        ];
        return fields;
    }

    getSmtpTypes(): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.dictionary.smtpTypes.api;
        return this.requestService.get(url, {verbose: true, type: 'api'});
    }

    getFormattedAddress(address: any) {
        // Synced with Agora. Do not change!
        let keys = ['firstName', 'lastName', 'streetName', 'zipCode'];
        let result = '';

        keys.forEach((el, i) => {
            if (result.length > 0) result += ' ';
            result += address[el] || '-';
            if (i > 0 && i < 3) result += ' /';
        });

        return result;
    }

    getDetailsAdditionalFields() {
        let fields = [
            {
                key: 'registrationNumber',
                label: 'Registration Number',
                type: 'text'
            },
            // {
            //     key: 'creditLimitAmount',
            //     label: 'Credit Limit Amount',
            //     type: 'text'
            // }, {
            //     key: (item) => {
            //         return item.creditLimitCurrency || (item.currency ? item.currency.configKey : '');
            //     },
            //     label: 'Credit Limit Currency',
            //     type: 'text'
            // },
            {
                key: 'accountReplyTo',
                label: 'Account Reply To E-mail',
                type: 'text',
            }, {
                key: (item) => {
                    if (item.website && (item.website.indexOf('https') !== -1)) {
                        return item.website
                    } else {
                        return 'https://' + item.website;
                    }
                },
                label: 'Website',
                type: 'link',
                config: {
                    placeholder: 'website'
                }
            }, {
                key: 'duns',
                label: 'Dun & Bradstreet Number (DUNS)',
                type: 'text'
            }, {
                key: 'chamberOfCommerceId',
                label: 'Chamber of Commerce ID',
                type: 'text'
            }, {
                key: 'vatNumber',
                label: 'VAT Number',
                type: 'text'
            }, {
                key: 'companyHolding',
                label: 'Company Holding',
                type: 'text'
            }, {
                key: 'active',
                label: 'Active',
                type: 'boolean'
            }, {
                key: 'contracted',
                label: 'Contracted',
                type: 'boolean'
            }, {
                key: 'associatedCompany.configValue',
                label: 'Associated Company',
                type: 'text'
            }, {
                key: 'salesOrganization.configValue',
                label: 'Sales Organization',
                type: 'text'
            }, {
                key: 'paymentTerm.configValue',
                label: 'Payment Term',
                type: 'text'
            }, {
                key: 'dunningEmail',
                label: 'Dunning Email Address',
                type: 'text'
            }
        ];
        return fields;
    }


    getGmailSmtpFields() {
        return [
            {
                key: 'type.configValue',
                label: 'SMTP type',
                type: 'text'
            },
            {
                key: 'username',
                label: 'Email',
                type: 'text'
            },
            {
                key: 'label',
                label: 'Label',
                type: 'text'
            },
            {
                key: 'isDefault',
                label: 'Activated',
                type: 'text'
            }
        ];
    }

    getDetailsSmtpfields() {
        let fields = [
            {
                key: 'type.configValue',
                label: 'SMTP type',
                type: 'text'
            },
            {
                key: 'label',
                label: 'Label',
                type: 'text'
            },
            {
                key: 'from',
                label: 'From',
                type: 'text'
            },
            {
                key: 'host',
                label: 'Host',
                type: 'text'
            },
            {
                key: 'username',
                label: 'Username',
                type: 'text'
            },
            {
                key: 'port',
                label: 'Port',
                type: 'text'
            },
            {
                key: 'isDefault',
                label: 'Activated',
                type: 'text'
            }
        ];
        return fields;
    }

    getDetailsPrintLogoFields() {
        let fields = [
            {
                key: 'printLogo',
                label: 'Print Logo',

                type: 'link',
                config: {
                    placeholder: 'Download'
                }
            }
        ];
        return fields;
    }

    getDetailsBrandedLogoFields() {
        let fields = [
            {
                key: 'brandedPortalLogo',
                label: 'Branded Portal Logo',
                type: 'link',
                config: {
                    placeholder: 'Download'
                }
            }
        ];
        return fields;
    }

    getDetailsPricelistFields() {
        let fields = [
            {
                key: 'pricelistUrl',
                label: 'Price List',
                type: 'download',
                config: {
                    placeholder: 'Download',
                    makeRequest: url => this.requestService.get(url, {attachment: true}, 'blob')
                }
            }
        ];
        return fields;
    }

    getEditMainFields() {
        let fields = [
            {
                key: 'id',
                label: 'ID',
                type: 'hidden',
                required: false
            }, {
                key: 'accountId',
                label: 'Account ID',
                type: 'hidden',
                required: false
            }, {
                key: 'classificationLevel.id',
                label: 'Classification Level',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.classificationLevel.api
            }, {
                key: 'name',
                label: 'Account Name',
                type: 'textbox',
                maxlength: '40',
                required: true
            }, {
                key: 'email',
                label: 'E-mail',
                type: 'textbox',
                required: true
            }, {
                key: 'language.id',
                label: 'Language',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.language.api
            },
            // {
            //     key: 'currency.id',
            //     label: 'Currency',
            //     type: 'dropdown',
            //     required: true,
            //     dictionaryUrl:
            //             this.configService.get('server').url +
            //             this.configService.get('endpoints').agora.dictionary.currency.api
            // },
            {
                key: 'watermark',
                label: 'Print Name',
                type: 'textbox',
                maxlength: '30',
                required: false
            },
            {
                key: 'procureFromContractedSuppliers',
                label: 'Procure from My Contracted Suppliers only',
                type: 'radio',
                required: false,
                options: [
                    {key: true, value: 'Yes'},
                    {key: false, value: 'No'}
                ],
                default: false
            },
            // {
            //     key: 'allowPayTM',
            //     label: 'Allow PayTM',
            //     type: 'hidden',
            //     required: false
            //
            // }
        ];
        return fields;
    }


    getEditSegmentsFields() {
        let fields = [
            {
                key: 'id',
                label: 'ID',
                type: 'hidden',
                required: false
            },
            {
                key: 'accountId',
                label: 'Account ID',
                type: 'hidden',
                required: false
            },
            {
                key: 'accountSellerSegments',
                label: 'Seller Managed Segments',
                type: 'multi-dropdown',
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.sellerSegments.api
            },
            {
                key: 'accountAccreditations',
                label: 'Account Accreditations',
                type: 'multi-dropdown',
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.accountAccreditations.api
            },
            {
                key: 'accountSegments',
                label: 'Account Segments',
                type: 'multi-dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.accountSegments.api
            },
            {
                key: 'accountComputedSegments',
                label: 'Account Computed Segments',
                type: 'list',
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.accountComputedSegments.api
            },
            {
                key: 'organizationType.id',
                label: 'Organization Type',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.organizationType.api
            }
        ];
        return fields;
    }

    getEditAddressesFields(domain: string) {
        let fields = [
            {
                key: 'id',
                label: 'ID',
                type: 'hidden',
                required: false
            },
            {
                key: 'accountId',
                label: 'Account ID',
                type: 'hidden',
                required: false
            },
            {
                key: 'shipToAddresses',
                label: 'Shiping Addresses',
                type: 'multi-dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.address.api +
                    '/temp/' +
                    domain
            },
            {
                key: 'billToAddresses',
                label: 'Billing Addresses',
                type: 'multi-dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.address.api +
                    '/temp/' +
                    domain
            },
            {
                key: 'mainAddress.id',
                label: 'Primary Address',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.address.api +
                    '/temp/' +
                    domain
            },
            {
                key: 'defaultShipToAddress.id',
                label: 'Default Shiping Address',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.address.api +
                    '/temp/' +
                    domain
            },
            {
                key: 'defaultBillToAddress.id',
                label: 'Default Billing Address',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.address.api +
                    '/temp/' +
                    domain
            }
        ];
        return fields;
    }

    getEditAdditionalFields() {
        let fields = [
            {
                key: 'additionalName',
                label: 'Additional Name',
                type: 'textbox',
                required: false
            }, {
                key: 'registrationNumber',
                label: 'Registration Number',
                type: 'textbox',
                required: false
            },
            // {
            //     key: 'creditLimitAmount',
            //     label: 'Credit Limit Amount',
            //     type: 'textbox',
            //     required: false
            //     // disabled: true
            // }, {
            //     key: 'creditLimitCurrency',
            //     label: 'Credit Limit Currency',
            //     type: 'dropdown',
            //     required: false,
            //     dictionaryUrl:
            //         this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.currencyDummy.api,
            //     // disabled: true
            // },
            {
                key: 'accountReplyTo',
                label: 'Account Reply To E-mail',
                type: 'textbox',
                pattern: this.configService.get('validators').email,
                required: false
            }, {
                key: 'website',
                label: 'Website',
                type: 'textbox',
                required: false
            }, {
                key: 'duns',
                label: 'Dun & Bradstreet Number (DUNS)',
                type: 'textbox',
                required: false
            }, {
                key: 'chamberOfCommerceId',
                label: 'Chamber of Commerce ID',
                type: 'textbox',
                required: false
            }, {
                key: 'vatNumber',
                label: 'VAT Number',
                type: 'textbox',
                required: false
            }, {
                key: 'companyHolding',
                label: 'Company Holding',
                type: 'textbox',
                required: false
            }, {
                key: 'active',
                label: 'Active',
                type: 'radio',
                required: false,
                options: [
                    {key: true, value: 'Yes'},
                    {key: false, value: 'No'}
                ],
                default: false
            }, {
                key: 'associatedCompany.id',
                label: 'Associated Company',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.associatedCompany.api
            }, {
                key: 'salesOrganization.id',
                label: 'Sales Organization',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.salesOrganization.api
            }, {
                key: 'paymentTerm.id',
                label: 'Payment Term',
                type: 'dropdown',
                required: false,
                // disabled: true,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.paymentTerm.api
            }, {
                key: 'dunningEmail',
                label: 'Dunning Email Address',
                type: 'textbox',
                pattern: this.configService.get('validators').email,
                required: false
            }
        ];
        return fields;
    }


    getEditSmtpFields() {
        let fields = [
            {
                key: 'smtpDetails.label',
                label: 'Label',
                type: 'textbox'
            },
            {
                key: 'smtpDetails.host',
                label: 'Host',
                type: 'textbox'
            },
            {
                key: 'smtpDetails.username',
                label: 'Username',
                type: 'textbox'
            },
            {
                key: 'smtpDetails.password',
                label: 'Password',
                type: 'textbox',
                inputType: 'password'
            },
            {
                key: 'smtpDetails.port',
                label: 'Port',
                type: 'textbox'
            },
            {
                key: 'smtpDetails.isDefault',
                label: 'Is Default',
                type: 'radio',
                options: [{key: true, value: 'Yes'}, {key: false, value: 'No'}]
            }
        ];
        return fields;
    }

    getSellerAccountDetailsFields() {
        let fields = [
            {
                id: 'aboutSeller',
                key: 'aboutSeller',
                label: 'About the Seller',
                type: 'html'
            },
            {
                key: 'supportEmail',
                label: 'Support Email',
                type: 'text'
            },
            {
                key: 'examFulfilmentEmail',
                label: 'Exam Fulfillment Email',
                type: 'text'
            },
            {
                key: 'manualDeliveryEmail',
                label: 'Manual Delivery Email',
                type: 'text'
            },
            {
                key: 'fixed',
                label: 'Fixed Price',
                type: 'boolean'
            },
            {
                key: 'sellerProceedsCurrency.configValue',
                label: 'Settlement Currency',
                type: 'text'
            }
        ];
        return fields;
    }

    getSellerAccountProceedsDetailsFields() {
        let fields = [
            {
                key: 'proceeds',
                label: 'Seller Proceeds',
                type: 'table',
                config: [
                    {
                        title: 'Type',
                        name: 'label'
                    },
                    {
                        title: 'Platform Fee',
                        getter: item => {
                            return (100 - item.percent) + ' %'
                        },
                    },
                    {
                        title: 'Max (USD)',
                        name: 'max'
                    },
                    {
                        title: 'Min (USD)',
                        name: 'min'
                    }
                ]
            }
        ];
        return fields;
    }

    getCatalogDetailsFields() {
        let fields = [
            {
                key: 'grantAccess',
                label: 'Grant Access',
                type: 'boolean'
            },
            {
                key: 'landingTab',
                label: 'Landing Tab',
                type: 'text'
            },
            {
                key: 'selfRegistration',
                label: 'Self Registration',
                type: 'boolean'
            },
            {
                key: 'details',
                label: 'Details',
                type: 'text'
            },
            {
                key: 'suppressCoverPage',
                label: 'Suppress Cover Page',
                type: 'boolean'
            },
            {
                key: 'printRestriction',
                label: 'Print Restriction',
                type: 'boolean'
            },
            {
                key: 'availableForConsumptionVouchers',
                label: 'Consumption Vouchers',
                type: 'boolean'
            },
            {
                key: 'calendar.configValue',
                label: 'Calendar',
                type: 'text'
            },
            {
                key: 'icalOrganizerDisplayName',
                label: 'iCal Organizer Display Name',
                type: 'text'
            },
            {
                key: 'icalOrganizerEmail',
                label: 'iCal Organizer Email',
                type: 'text'
            },
            {
                key: 'enableCompletionButton',
                label: 'Show \'Mark as Completed\' Button',
                type: 'boolean'
            }
        ];
        return fields;
    }

    fetchAccountFeaturesDetails(domain: string) {
        let url = this.configService.get('server').sahara + this.configService.get('endpoints').sahara.accountFeatures.details.api
        + '/' + domain;

        return this.requestService.get(url);
    }

    getAccountFeaturesFields() {
        return [
            {
                key: 'accountFeatures.lmsEnabled.enabled',
                label: 'LMS Enabled',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.lmsEnabled.nestedFlags.hostedExams',
                label: '(Mettl) Hosted Exams',
                type: 'boolean',
                disabled: 'accountFeatures.lmsEnabled.enabled'
            },
            {
                key: 'accountFeatures.lmsEnabled.nestedFlags.selfPaced',
                label: 'Self-paced',
                type: 'boolean',
                disabled: 'accountFeatures.lmsEnabled.enabled'
            },
            {
                key: 'accountFeatures.vmsEnabled',
                label: 'VMS Enabled',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.classes',
                label: 'Classes',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.voucherManagement',
                label: 'Voucher Management',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.marketplace',
                label: 'Marketplace',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.contracts',
                label: 'Contracts',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.ordersAndInvoices',
                label: 'Orders and Invoices',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.customAttributes',
                label: 'Custom Attributes',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.webcamAssessments',
                label: 'Webcam Assessments',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.integration.enabled',
                label: 'Integration',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.integration.nestedFlags.coursePublishing',
                label: 'Course Publishing',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.integration.nestedFlags.productPublishing',
                label: 'Product Publishing',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.integration.nestedFlags.supplierInvitation',
                label: 'Supplier Invitation',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.integration.nestedFlags.ssoConfiguration',
                label: 'SSO Configuration',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.integration.nestedFlags.apiConfiguration',
                label: 'API Configuration',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.integration.nestedFlags.exportAssignmentData',
                label: 'Assignment Data Export',
                type: 'boolean'
            },
            {
                key: 'courseEventRetail',
                label: 'Individual Retail Course Event Purchases Allowed',
                type: 'boolean'
            },
            {
                key: 'accountFeatures.externalFulfilmentEnabled',
                label: 'External Fulfilment Enabled',
                type: 'boolean'
            }
        ];
    }

    getEditCatalogDetailsFields() {
        let fields = [
            {
                key: 'grantAccess',
                label: 'Grant Access',
                type: 'radio',
                required: false,
                options: [
                    {key: true, value: 'Yes'},
                    {key: false, value: 'No'}
                ],
                default: false
            },
            {
                key: 'landingTab',
                label: 'Landing Tab',
                type: 'combobox-single-select',
                required: false,
                config: {hardCodedOptions: [{key: 'CATALOG', value: 'Catalog'}, {key: 'ASSIGNMENTS', value: 'Assignments'}]},
                // default: 'CATALOG'
            },
            {
                key: 'selfRegistration',
                label: 'Self Registration',
                type: 'radio',
                required: false,
                options: [
                    {key: true, value: 'Yes'},
                    {key: false, value: 'No'}
                ],
                default: false
            },
            {
                key: 'details',
                label: 'Details',
                type: 'textbox'
            },
            {
                key: 'suppressCoverPage',
                label: 'Suppress Cover Page',
                type: 'radio',
                required: false,
                options: [
                    {key: true, value: 'Yes'},
                    {key: false, value: 'No'}
                ],
                default: false
            },
            {
                key: 'printRestriction',
                label: 'Print Restriction',
                type: 'radio',
                required: false,
                options: [
                    {key: true, value: 'Yes'},
                    {key: false, value: 'No'}
                ],
                default: false
            }, {
                key: 'availableForConsumptionVouchers',
                label: 'Consumption Vouchers',
                type: 'radio',
                required: false,
                options: [
                    {key: true, value: 'Yes'},
                    {key: false, value: 'No'}
                ],
                default: false
            }, {
                key: 'calendar.id',
                label: 'Calendar',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.calendar.api
            },
            {
                key: 'icalOrganizerDisplayName',
                label: 'iCal Organizer Display Name',
                type: 'textbox'
            },
            {
                key: 'icalOrganizerEmail',
                label: 'iCal Organizer Email',
                type: 'textbox'
            },
            {
                key: 'enableCompletionButton',
                label: 'Show \'Mark as Completed\' Button',
                type: 'radio',
                required: false,
                options: [
                    {key: true, value: 'Yes'},
                    {key: false, value: 'No'}
                ],
                default: false
            }
        ];
        return fields;
    }

    // Added by Sanjay - Remove Credit application HTTP post
    removeCreditApplication(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.credit.remove.api;
        return this.requestService.post(url, details);
    }

    // Added by Sanjay - Get Finance details fields
    getDetailsFinanceFields() {
        let fields = [
            {
                key: 'currency.configValue',
                label: 'Transaction Currency',
                type: 'text'
            },
            {
                key: item => {
                    return item.limit ? item.limit : 'no credit';
                },
                label: 'Credit Limit',
                type: 'text'
            },
            {
                key: item => {
                    return item.creditCurrency || (item.currency ? item.currency.configKey : '');
                },
                label: 'Credit Limit Currency',
                type: 'text'
            },
            {
                key: item => {
                    return item.billingInfo;
                },
                label: 'Billing Info',
                type: 'text'
            },
            {
                key: item => {
                    let currency = item.creditCurrency ? item.creditCurrency : '';
                    let amount = item.used ? item.used : '';
                    return currency + ' ' + amount;
                },
                label: 'Open Amount',
                type: 'text'
            },
            {
                key: item => {
                    let currency = item.creditCurrency ? item.creditCurrency : '';
                    let amount = item.available ? item.available : '';
                    return currency + ' ' + amount;
                },
                label: 'Remaining Credit',
                type: 'text'
            },
            {
                key: 'paymentTerm.configValue',
                label: 'Payment Term',
                type: 'text'
            },
            {
                key: 'consolidationOrdersEnabled',
                label: 'Consumption Invoicing Enabled',
                type: 'boolean'
            },
            {
                key: 'consolidationOrdersFrequency.configValue',
                label: 'Consumption Invoicing Term',
                type: 'text'
            },
            {
                key: 'payTmPaymentGatewayEnabled',
                label: 'PayTm Payment Gateway Enabled',
                type: 'boolean'
            },
            // ,
            // {
            //   key: 'levelPolicyName',
            //   label: 'Debtor Level Policy',
            //   type: 'text'
            // },
            // {
            //   key: 'actionPolicyName',
            //   label: 'Debtor Action Policy',
            //   type: 'text'
            // }
        ];
        return fields;
    }

    getLevelPolicies(): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.levelPolicies.api;
        return this.requestService.get(url);
    }

    getActionPolicies(): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.actionPolicies.api;
        return this.requestService.get(url);
    }

    editFinance(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.editFinance.api;
        return this.requestService.post(url, details);
    }

    editCatalog(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.editCatalog.api + '/' + details.domain;
        delete details['domain'];
        return this.requestService.post(url, details);
    }

    editAccountFeatures(details: any): Observable<any> {
        let url = this.configService.get('server').sahara + this.configService.get('endpoints').sahara.accountFeatures.edit.api;
        return this.requestService.post(url, details);
    }

    editSellerAccount(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.editSellerAccount.api;
        return this.requestService.post(url, details);
    }

    getCreditDetails(accountId: string, currency: string): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.creditDetails.api + '/' + accountId + '?currency=' + currency;
        return this.requestService.get(url);
    }

    addCreditCardSegment(details: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.accounts.addCreditCardSegment.api;
        return this.requestService.post(url, details);
    }

    getViltCatalogsPerDomain(domain: any): Observable<any> {
        let url =
            this.configService.get('server').url +
            this.configService.get('endpoints').agora.catalogs.vILTCatalogList.api + domain;
        return this.requestService.get(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/account.service.ts